import { render } from "./taxrates.vue?vue&type=template&id=3f1d74c7"
import script from "./taxrates.vue?vue&type=script&lang=js"
export * from "./taxrates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__